import ReportsAdapter from './base';

export default class RubricElement extends ReportsAdapter {
  modelNamePlural = 'rubric-elements';
}
